export default __webpack_public_path__ + "static/media/undraw_road_sign.cb434be8.svg";